import React from 'react';

import type { SessionData } from '../../../../../../../../public-src/core/js/schibsted-account/types.js';

import { LoginButton } from './LoginButton.js';

interface DisclaimerProps {
  showLoginPrompt: boolean;
  isExpired: boolean;
  requiresLogin: boolean | undefined;
  session: SessionData | null;
}

const Disclaimer: React.FC<DisclaimerProps> = ({
  showLoginPrompt,
  isExpired,
  requiresLogin,
  session,
}: DisclaimerProps) => {
  if (isExpired)
    return (
      <p className="disclaimer-expired">
        Spørreundersøkelsen er over! Husk å bli med neste gang – din mening er
        viktig for oss!
      </p>
    );

  if (
    typeof window !== 'undefined' &&
    requiresLogin &&
    session === false &&
    !showLoginPrompt
  ) {
    return (
      <p className="disclaimer-login-prompt">
        Hei der! <LoginButton /> og få stemmen din telt!
      </p>
    );
  }

  if (showLoginPrompt)
    return (
      <div className="poll-login-disclaimer">
        <p>
          <span>Oops! Du er ikke logget inn.</span>
          For å holde tjenesten trygg og rettferdig, må du logge inn for å
          stemme - det er helt gratis!
        </p>
        <LoginButton />
      </div>
    );

  return null;
};

export { Disclaimer };
